import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/ether/banner_back.webp";

function banner() {
  return (
    <section
      className="banner_ether text_white"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#141826" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/ether/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={344}
                height={172}
              />
            </div>
            <h1>Ether Legends Collectible Trading Card Game</h1>
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/ether/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1060}
                height={693}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={8}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="banner_content">
              <h2>Blockchain Game App Development</h2>
              <p>
                Ether Legends is an artful, lighthearted NFT blockchain
                collectible trading card game that’s powered by Enjin, Polygon
                and the Ethereum Network. Players have the opportunity to earn
                via playing and while collecting NFT companions and characters
                in order to more intensively engage in the multi-player trading
                card game.
              </p>
              <p>
                Ether Legends is a unique concept that’s based on collecting
                various tokens for in-game modifiers to earn more, with engaging
                PVPbattle that offers players to continually scale up their
                characters, companions and more.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="resp_order">
            <div className="req_ether_img">
              <StaticImage
                src="../../../images/case-studies/ether/req_ether.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={815}
                height={608}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>The Underlying Concept & Requirement</h2>
            <p>
              As per recent research, people and governments, the blockchain and
              NFT space is one of fastest and most significantly growing one,
              with people increasingly investing time and money. Indeed,
              according to Statista, the global spending on Blockchain-related
              solutions will be approximately $6.6 billion by the end of 2021
              and is projected to expand to $19 billion by the end of 2024. The
              gaming industry and concept of owning your game content through
              tokenization is only expected to grow with the help of Blockchain
              technologies
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default banner;
